import { useEffect, useState, useCallback } from 'react';
import { utcToZonedTime } from 'date-fns-tz';

import { useIsSupportPanelOpen } from 'state/isSupportPanelOpen';
import { zone, getTodaysOpeningHours, isDateHoliday } from 'utils/openingHours';
import { isLoggedInUser } from 'utils/isLoggedInUser';

const OPENING_HOURS_INTERVAL = 30 * 1000;

export const useOpenningHoursEffect = () => {
  const isSupportPanelOpen = useIsSupportPanelOpen();
  const [isOutOfHours, setIsOutOfHours] = useState(false);

  const isInOpeningHours = (now) => {
    const zoneNow = utcToZonedTime(now, zone);
    const timestamp = zoneNow.getTime();
    const [openingTime, closingTime] = getTodaysOpeningHours(zoneNow);

    return timestamp > openingTime && timestamp < closingTime;
  };

  const updateIsOutOfHours = useCallback(() => {
    if (isLoggedInUser()) {
      setIsOutOfHours(false);

      return;
    }

    // Out of office should be configured in Tealium for a channel to activate the feature
    if (!window.utag_data?.chat_opening_hours) {
      setIsOutOfHours(false);

      return;
    }

    const today = new Date();
    const isOpeningHours = isInOpeningHours(today);
    const isHoliday = isDateHoliday(today);

    setIsOutOfHours(isHoliday || !isOpeningHours);
  }, []);

  useEffect(() => {
    updateIsOutOfHours();
  }, [updateIsOutOfHours]);

  useEffect(() => {
    const chatUnavailableInterval =
      !!isSupportPanelOpen &&
      setInterval(() => updateIsOutOfHours(), OPENING_HOURS_INTERVAL);

    return () => {
      !!chatUnavailableInterval && clearInterval(chatUnavailableInterval);
    };
  }, [isSupportPanelOpen, updateIsOutOfHours]);

  return { isOutOfHours };
};
